import { useEffect, useRef, useState } from 'react';

import { useHistory } from 'react-router';

import routes from 'constants/routes';
import i18n from 'i18n/config';
import { GreenCircleTick } from 'styles/assets/icons';
import Box from 'UIKit/Box';

import styles from './disable2faFaceAuth.module.scss';

const textSelfieVerificationSuccess = i18n.t<string>(
  'auth:twoFaFaceAuth.selfieVerificationSuccess'
);

const Reset2faComplete = () => {
  const [redirectTimeInSecs, setRedirectTimeInSecs] = useState(5);

  const intervalId = useRef<NodeJS.Timeout | null>(null);

  const history = useHistory();

  useEffect(() => {
    intervalId.current = setInterval(() => {
      setRedirectTimeInSecs(prev => prev - 1);
    }, 1000);

    return () => clearInterval(intervalId.current!);
  }, []);

  useEffect(() => {
    if (redirectTimeInSecs === 0) {
      history.replace(routes.login);
    }
  }, [redirectTimeInSecs, history]);

  return (
    (<div className={styles.successContainer} data-palette="Reset2faComplete">
      <GreenCircleTick className={styles.icon} height={80} width={80} />
      <Box
        as="h2"
        data-testid="success-heading"
        fontSize="lg2"
        className={styles.successHeading}
      >
        {textSelfieVerificationSuccess}
      </Box>
      <Box as="h4" className={styles.successDescription}>
        {i18n.t<string>('auth:twoFaFaceAuth.successfullyDisabled2fa', {
          timer: redirectTimeInSecs,
        })}
      </Box>
    </div>)
  );
};

export default Reset2faComplete;
